import React from 'react';
import type {NativeStackScreenProps} from '@react-navigation/native-stack';

import {useAuthStore} from '@/entities/session/auth-store';
import type {PersonnelStackParamList} from '@/app/routes';
import {PersonnelCard} from '@/features/manage-personnel/ui/PersonnelCard';
import {Page} from '@/shared/ui/page';

/** «Сотрудники» → карточка с действиями: правка, приглашение, удаление. */
type Props = NativeStackScreenProps<PersonnelStackParamList, 'PersonnelCard'>;

export function PersonnelCardScreen({route, navigation}: Props) {
  const companyId = useAuthStore(s => s.activeContext?.companyId);
  const {recordId, name} = route.params;

  return (
    <Page scroll width="form" title={name} testID="staff-card">
      {companyId ? (
        <PersonnelCard
          companyId={companyId}
          recordId={recordId}
          personName={name}
          onEdit={() => navigation.navigate('PersonnelForm', {recordId, name})}
          // Человека больше нет: подниматься «на уровень вверх» некуда — вверх
          // это и есть его карточка. Уходим в список явно.
          onDeleted={() => navigation.popTo('PersonnelList')}
        />
      ) : null}
    </Page>
  );
}
